import $ from 'jquery';
import mousewheel from 'jquery-mousewheel';

class Chart {
  constructor(target) {
    this.target = target;
    this.title = target.find('h3');
    this.table = target.find('.erabikata__chartContent');

    this.title.click(
      function () {
        this.table.slideToggle();
        this.target.toggleClass('erabikata__chart--open');
      }.bind(this),
    );



    var moving;
    // 1スクロールの移動距離
    var speed = 30;
    $('.erabikata__3colLiContentTable').mousewheel(function(event, mov) {
        //  スクロール後の位置の算出
        var moving = $(this).scrollLeft() - mov * speed;
        // スクロールする
        // console.log(mov,$('.erabikata__table').width(),$(this).scrollLeft());
        $(this).scrollLeft(moving);
        // 縦スクロールさせない
        return false;
    });

  }
}

(() => {
  const targets = $('.erabikata__chart');
  if (!targets.length) return;
  new Chart(targets);
})();
